import { render, staticRenderFns } from "./Onepage.vue?vue&type=template&id=720ca102&scoped=true&"
import script from "./Onepage.vue?vue&type=script&lang=js&"
export * from "./Onepage.vue?vue&type=script&lang=js&"
import style0 from "./Onepage.vue?vue&type=style&index=0&id=720ca102&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720ca102",
  null
  
)

export default component.exports